import React from "react";
import { itensSeusDireitos } from "../../constants/SeusDireitosItens";
import SectionCard from "../SectionCard/SectionCard";

function SeusDireitos() {
  const subtext1 = (
    <p>
      A<b> Lei Geral de Proteção de Dados </b> (Lei nº 13.709/2018) garante uma
      série de direitos relacionados à proteção dos seus dados pessoais, para
      que suas escolhas sejam respeitadas e para que você tenha o controle de
      como estamos utilizando suas informações. A seguir, descrevemos quais são
      eles e como você pode exercê-los aqui.
    </p>
  );

  return (
    <SectionCard
      id="Seusdireitos"
      title="Seus Direitos"
      subtext1={subtext1}
      itens={itensSeusDireitos}
    />
  );
}

export default SeusDireitos;
